import CenteredCard from './CenteredCard';

export default CenteredCard;
